import { toast } from "react-toastify";
import { upload_file_to_s3 } from "../../utils";

const s3_Upload = async (new_file) => {
  const file = new_file.target.files[0];
  if (!file) {
    toast.error("please select a file");
    return;
  }
  const file_to_upload = file;
  let awsS3uploadedDTO;
  const maxSizeInBytes = 10 * 1024 * 1024; // max 10mb

  if (file_to_upload?.size > maxSizeInBytes) {
    toast.error("File size limit is 10Mb");
    return;
  }
  try {
    const s3path = await upload_file_to_s3(file);
    awsS3uploadedDTO = s3path?.data?.data;
    const date = new Date();
    const formattedDate = date.toISOString();
    const fileData = {
      fileName: file.name,
      name: new_file.target.name,
      resourceName: "", // You can set the file url as needed
      uploadDate: formattedDate,
      comment: "",
      extension: file_to_upload.name.split(".").pop(), // Extract file extension
      s3Document: awsS3uploadedDTO,
    };
    return fileData;
  } catch (e) {
    console.error(e, "erororr345");
    return e;
  }
};

export default s3_Upload;
